<template>
  <v-layout
    id="content-edit-form"
    justify-center
    wrap
  >
    <v-flex
      xs12
      md8
      lg8
    >
      <h2 v-if="!content">
        {{ $t('modules.cms.contentNew') }}
      </h2>
      <h2 v-else>
        {{ $t('modules.cms.contentEdit') }}
      </h2>
      <v-card class="pt-7 pl-5 pr-5">
        <v-form @submit.prevent="save">
          <v-layout wrap>
            <v-flex
              xs12
              class="text-center select-icon"
            >
              <p :class="IconErrors.length !== 0 ? 'select-icon_error' : ''">
                {{ $t('modules.cms.selectIcon') }}*
              </p>
              <div
                class="select-icon_icon"
                @click.stop="iconsDialog = true"
              >
                <v-icon
                  v-if="form.icon"
                  x-large
                >
                  {{ form.icon }}
                </v-icon>
                <v-icon
                  v-else
                  x-large
                >
                  mdi-image-outline
                </v-icon>
              </div>
              <p
                v-if="IconErrors.length !== 0"
                class="select-icon_error"
                style="margin-top: 16px; margin-bottom: 0; font-size: 12px;"
              >
                {{ IconErrors[0] }}
              </p>
            </v-flex>
            <v-flex
              xs12
            >
              <v-text-field
                v-model.trim="form.name"
                :error-messages="NameErrors"
                :label="$t('modules.cms.formName')+ '*'"
                @input="$v.form.name.$touch()"
                @blur="$v.form.name.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
            >
              <v-text-field
                v-model.trim="form.url"
                :error-messages="UrlErrors"
                :label="$t('modules.cms.url')+ '*'"
                @input="$v.form.url.$touch()"
                @blur="$v.form.url.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
            >
              <v-select
                v-model.trim="form.template_name"
                :items="templateName"
                :item-text="'text'"
                :item-value="'value'"
                :error-messages="TemplateNameErrors"
                :label="$t('modules.cms.headerTable.template')+'*'"
                @blur="$v.form.template_name.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
            >
              <v-select
                v-model.trim="form.request_method"
                :items="requestMethod"
                :item-text="'text'"
                :item-value="'value'"
                :error-messages="RequestMethodErrors"
                :label="$t('modules.cms.requestMethod')+'*'"
                @blur="$v.form.request_method.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
            >
              <b>{{ $t("modules.cms.token") }}</b>
            </v-flex>
            <v-flex
              xs12
            >
              <v-textarea
                v-model.trim="form.token"
                outlined
                :error-messages="TokenErrors"
                no-resize
                @input="$v.form.token.$touch()"
                @blur="$v.form.token.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
            >
              <v-text-field
                v-model.trim="form.sort_order"
                :error-messages="SortOrderError"
                :label="$t('modules.cms.sortOrder')+ '*'"
                @input="$v.form.sort_order.$touch()"
                @blur="$v.form.sort_order.$touch()"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md12
            >
              <v-btn
                fab
                outlined
                small
                text
                @click="$emit('closeEditMode', false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                color="primary"
                style="float:right"
                :disabled="loading"
                :loading="loading"
                @click="save"
              >
                {{ $t('globals.saveButton') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-flex>
    <SelectIconsDialog 
      v-if="iconsDialog"
      :show-dialog="iconsDialog"
      @closeIconsDialog="closeIconsDialog"
      @selectedIcon="selectedIcon"
    />
  </v-layout>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import CMS_CREATE_MUTATION from "@/graphql/mutations/modules/CmsCreate.gql"; 
import CMS_UPDATE_MUTATION from "@/graphql/mutations/modules/CmsUpdate.gql";

import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
  integer,
  numeric,
  url
} from "vuelidate/lib/validators";

import SelectIconsDialog from "./patrial/SelectIconsDialog.vue";

export default {
  name: "ModuleCmsEditForm",
  components: {
    SelectIconsDialog,
  },
  mixins: [validationMixin],
  props: {
    content: {
      type: Object,
      default: null
    },
    whitelabelUuid: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      iconsDialog: false,
      templateName: [
        {value: "default", text: this.$t('modules.cms.default')},
        {value: "news", text: this.$t('modules.cms.news')},
        {value: "education", text: this.$t('modules.cms.education')},
        {value: "documents", text: this.$t('modules.cms.documents')},
        {value: "help", text: this.$t('modules.cms.help')},
        {value: "banners", text: this.$t('modules.cms.banners')},
      ],
      requestMethod: [
        {value: "POST", text: "POST"},
        {value: "GET", text: "GET"}
      ],
      form: {
        icon: "",
        name: "",
        template_name: "",
        url: "",
        request_method: "",
        token: "",
        sort_order: null,
      }
    }
  },
  computed: {
    rules() {
      return {
        icon: {
          required,
        },
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(15),
        },
        template_name: {
          required,
        },
        url: {
         required,
         minLength: minLength(3),
         url
        },
        request_method: {
          required,
        },
        token: {
          maxLength: maxLength(1000),
        },
        sort_order: {
          required,
          numeric,
          integer,
          minValue: minValue(0),
          maxValue: maxValue(100000)
        },
      }
    },
    IconErrors() {
      const errors = [];
      if (!this.$v.form.icon.$dirty) return errors;
      !this.$v.form.icon.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    NameErrors(value) {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.name.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.name.$params.minLength.min}));
      !this.$v.form.name.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.name.$params.maxLength.max}));
      return errors;
    },
    UrlErrors(value) {
      const errors = [];
      if (!this.$v.form.url.$dirty) return errors;
      !this.$v.form.url.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.url.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.name.$params.minLength.min}));
      !this.$v.form.url.url &&
        errors.push(this.$t("modules.cms.urlError"));
      return errors;
    },
    TemplateNameErrors(value) {
      const errors = [];
      if (!this.$v.form.template_name.$dirty) return errors;
      !this.$v.form.template_name.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    RequestMethodErrors(value) {
      const errors = [];
      if (!this.$v.form.request_method.$dirty) return errors;
      !this.$v.form.request_method.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    TokenErrors() {
      const errors = [];
      if (!this.$v.form.token.$dirty) return errors;
      !this.$v.form.token.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.token.$params.maxLength.max}));
      return errors;
    },
    SortOrderError(){
      const errors = [];
      if (!this.$v.form.sort_order.$dirty) return errors;
      !this.$v.form.sort_order.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.sort_order.numeric &&
        errors.push(this.$t("deals.mustBeNumber"));
      !this.$v.form.sort_order.minValue &&
        errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.sort_order.$params.minValue.min}));
      !this.$v.form.sort_order.maxValue &&
        errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.sort_order.$params.maxValue.max}));
      return errors;
    },
  },
  mounted() {
    const form = JSON.parse(JSON.stringify(this.content))
    if (form) {
      this.form = form
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    closeIconsDialog(val) {
      this.iconsDialog = val;
    },
    selectedIcon(val) {
      this.form.icon = val;
      this.iconsDialog = false;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      }
      this.loading = true;
      this.form.whitelabel_uuid = this.whitelabelUuid;
      this.form.sort_order = +this.form.sort_order;
      if(!this.form.token) delete this.form.token;

      this.$apollo
        .mutate({
          mutation: !this.content ? CMS_CREATE_MUTATION : CMS_UPDATE_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.$emit('closeEditMode', true)
        })
        .catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error);
        });
    }
  },
}
</script>

<style lang="scss">
#content-edit-form {
  .select-icon {
    p {
      color: rgba(0, 0, 0, 0.6);
      font-size: 16px;
      font-weight: 500;
    }
    .select-icon_icon{
      cursor: pointer;
      max-width: 50px;
      margin: 0 auto;
    }
    .select-icon_error {
      color: #f55a4e;
    }
  }
  .image {
    width: 306px;
    margin: 0 auto;
    border: 3px solid;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    i {
      margin: 5px 0 0px;
      font-size: 26px;
    }
    p {
      margin: 7px 0 0!important;
      &:first-of-type {
        font-weight: 700;
      }
      line-height: 0.85rem;
    }
    small {
      font-size: 11px;
    }
    &.no-border {
      border: 0 !important;
    }
  }
}
</style>
